var _rect, _rect2, _rect3, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconTransmissionDocument = function SvgIconTransmissionDocument(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 4,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 4,
    fill: "#EFF0F8"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 4,
    stroke: "#B7B9DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1545 9.16386V7.58726C13.1545 7.32383 13.0497 7.07084 12.8633 6.88445L11.4577 5.47884C11.2713 5.29245 11.0183 5.18758 10.7548 5.18758H7.19011C6.64089 5.18758 6.19604 5.63242 6.19604 6.18165V13.1401C6.19604 13.6894 6.64089 14.1342 7.19011 14.1342H9.17825",
    stroke: "#575BAF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68726 8.1697H11.6635",
    stroke: "#575BAF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68726 9.66096H11.6635",
    stroke: "#575BAF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.68726 11.1521H8.68133",
    stroke: "#575BAF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5681 14.5154L10.4965 13.9761C10.4965 13.9761 10.4965 13.9761 10.4965 13.9756L10.166 13.5432C9.98406 13.3051 9.98406 12.9746 10.166 12.7365L10.4965 12.3041C10.4965 12.3041 10.4965 12.3041 10.4965 12.3036L10.5686 11.7638C10.6083 11.4666 10.8419 11.2329 11.1392 11.1932L11.6785 11.1216C11.6785 11.1216 11.6785 11.1216 11.679 11.1216L12.1114 10.7911C12.3495 10.6092 12.68 10.6092 12.9181 10.7911L13.3505 11.1216C13.3505 11.1216 13.3505 11.1216 13.351 11.1216L13.8908 11.1937C14.188 11.2334 14.4216 11.4671 14.4614 11.7643L14.5329 12.3036C14.5329 12.3036 14.5329 12.3036 14.5329 12.3041L14.8635 12.7365C15.0454 12.9746 15.0454 13.3051 14.8635 13.5432L14.5329 13.9756C14.5329 13.9756 14.5329 13.9756 14.5329 13.9761L14.4609 14.5159C14.4211 14.8131 14.1875 15.0467 13.8903 15.0865L13.351 15.158C13.351 15.158 13.351 15.158 13.3505 15.158L12.9181 15.4886C12.68 15.6705 12.3495 15.6705 12.1114 15.4886L11.679 15.158C11.679 15.158 11.679 15.158 11.6785 15.158L11.1387 15.086C10.8414 15.0467 10.6078 14.8126 10.5681 14.5154V14.5154Z",
    stroke: "#575BAF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2883 12.7535L12.3216 13.7202L11.7421 13.1402",
    stroke: "#575BAF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconTransmissionDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "icon-transmission-document.465d4e2355f52dfddbca1db0e7e7ea20.svg";